import { createContext } from 'react';

import type { ClickStreamMetadata } from '../../../constants/TouringClickStreamEvents';

type TourCalendarContextType = {
  clickStreamMetadata?: ClickStreamMetadata;
  /** Base lead-management path for this listing; a tour event's renter row links here. */
  inquiriesPath?: string;
  lastActivatedAt?: number;
  listingAlias?: string;
  listingAddress?: string;
  propertyPhotoUrl?: string;
  refetchTouringData?: () => void;
};

const TourCalendarContext = createContext<TourCalendarContextType>({
  clickStreamMetadata: undefined,
  inquiriesPath: undefined,
  lastActivatedAt: 0,
  listingAlias: '',
  listingAddress: '',
  propertyPhotoUrl: '',
  refetchTouringData: () => {},
});

export default TourCalendarContext;
